<template lang="html">
    <ModalDefault
        v-if="params && params.isActive"
        size="s"
        :with-content="true"
        @close="close();"
        :theme="true"
        :fix-height="false"
        :fix-width="false"
        :loading="false"
    >
        <template slot="main">
            <p class="modal-title mb-4">LOG CONTENT</p>

            <p class="m-0 log-content" v-html-safe="logContentFormatted"></p>
        </template>
    </ModalDefault>
</template>

<script lang="js">
import ModalDefault from "@/components/ui/ModalDefault";

export default {
    components: {ModalDefault},
    props: ['params'],
    data () {
        return {
        }
    },
    methods: {
        close() {
            this.params.isActive = false;
            this.$emit('close');
        }
    },
    computed: {
        logContentFormatted() {
            return this.params.logContent.replaceAll('\n', '<br>');
        }
    }
}
</script>

<style scoped lang="scss">
.log-content {
    max-height: 50vh;
    overflow-y: auto;
    padding: 10px;
    background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// LogContent.vue?61d108f1